module.exports = __webpack_public_path__ + "img/isteacher4.2a1d33ac.png";